import { render, staticRenderFns } from "./content_pages.vue?vue&type=template&id=53649eda"
import script from "./content_pages.vue?vue&type=script&lang=js"
export * from "./content_pages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports